import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Scroll.es.js";
const r = o.forwardRef((c, e) => /* @__PURE__ */ o.createElement(t, { ref: e, ...c, weights: a }));
r.displayName = "ScrollIcon";
const s = r;
export {
  s as Scroll,
  r as ScrollIcon
};
